import { Outlet } from 'react-router-dom'
import PortalHeader from './PortalHeader'
import Main from '../Main'
import Footer from '../Footer'
import {useLocation, useNavigate} from 'react-router'
import Background from '../Background'
import Loading from '../Loading'
import {useContext, useEffect} from 'react'
import AuthContext from '../../store/AuthContext'
import PoweredByContext from '../../store/PoweredByContext'
import PortalContext from '../../store/PortalContext'

const PortalLayout = ({privateRoutePage}) => {

    const navigate = useNavigate()
    

    // Auth context
    const authCtx = useContext(AuthContext)

    // Powered By context
    const poweredByCtx = useContext(PoweredByContext)

    const portalCtx = useContext(PortalContext)

    // Use alternate header on Home page
    const location = useLocation()
    let isHomepage = (location.pathname === '/' || location.pathname.includes('home'))
    let isLogin = (location.pathname.includes('login'))

    useEffect(() => {
        //console.log(portalCtx)
        if(!portalCtx.id && !isLogin) {
            navigate('/portal/login')
        }
    }, [portalCtx, isLogin])
    

    return (
        <>
            <div className='layout portalLayout'>
                <PortalHeader />
                <Main className='portalbg'>
                    <Outlet />
                </Main>
                <Footer />

            </div>
        </>
    )
}

export default PortalLayout